import { ButtonColor, ButtonDirection, ButtonDisplayType, ButtonSize } from '../button'
import { ApiResult } from '../remote-data'
import { IconDetails, TooltipDetails } from './table-column'

export interface ButtonDetails {
  size?: ButtonSize
  color?: ButtonColor
  direction?: ButtonDirection
  displayType?: ButtonDisplayType
  fullWidth?: boolean
  disabled?: boolean
  icon?: IconDetails
}

export interface TableAction<TInput, TResult = unknown> {
  actionFn: (t: TInput) => ApiResult<TResult>
  label: string
  button?: ButtonDetails | undefined
  successText: string | undefined
  failureText: string | undefined
  routerParams?: ((r: TResult) => string[]) | undefined
  showAction: (r: TInput) => boolean
  tooltipFn: (r: TInput) => TooltipDetails | undefined
  useApiFailureText: boolean
}

export class TableActionsBuilder<TInput> {
  actions: TableAction<TInput, any>[] = []

  /**
   * A submission followed by an optional redirect on success.
   *
   * Handles error/success notifications
   */
  addAction<TResult = unknown>(
    label: string,
    actionFn: (t: TInput) => ApiResult<TResult>,
    successText: string | undefined,
    failureText: string | undefined,
    button?: ButtonDetails | undefined,
    routerParams?: (r: TResult) => string[],
    useApiFailureText: boolean = false,
    showAction: (t: TInput) => boolean = () => true,
    tooltipFn?: (t: TInput) => TooltipDetails | undefined,
  ): this {
    this.actions.push({
      label,
      button,
      actionFn,
      successText,
      failureText,
      routerParams,
      useApiFailureText,
      showAction,
      tooltipFn: tooltipFn ?? ((_: TInput) => undefined),
    })

    return this
  }

  build(): TableAction<TInput>[] {
    return this.actions
  }
}
